<template>
    <div v-if="show" class="mask">
        <div  class="form-modal doc-edit-modal flex flex-col flex-space-between book">
            <div class="flex flex-space-between flex-center-cz title border-box">
                <div class="margin-left-l font-s">发送更新</div>
                <img src="@/assets/images/guanbi.png" class="logo-18 margin-right-m pointer" @click="close"/>
            </div>
            
            <div class="flex flex-col body padding-top-l border-box " style="height: calc(100% - 100px)" >
                <div>
                    <div class="flex flex-center-cz edit-area margin-top-m">
                        <div class="label margin-top-m">发送给</div>
                        <div class="value flex " style="width: 800px;">
                            <div class="margin-top-m margin-left-m">所有人</div>
                            <MySwitch v-model="formData.allUser"></MySwitch>
                            <div v-if="!formData.allUser" class="margin-left-l margin-top-s flex">
                                <div class="margin-top-s">指定人员</div>
                                <Select ref="selectVer" :data="verData" v-model="formData.selectVer"   style="width: 200px;"></Select>
                                <div class="margin-top-s margin-left-m margin-right-m">只保留该人员关键字所在行</div>
                                <MySwitch style="margin-top: -3px;" v-model="formData.onlyUser" @change="keep"></MySwitch>  
                            </div> 
                        
                        </div>
                    
                    </div>
                </div>

                <div class="flex flex-col margin-top-m">
                    <div class="flex flex-center-cz  edit-area margin-top-m">
                        <div class="label">更新内容</div>
                        <div class="value" id="content"> <RichText  class="full-width" v-model="formData.content"   /></div>
                    </div>
                </div>

            </div>
            <div class="flex flex-center-sp flex-center-cz toolbar border-box">
                <div class="margin-right-s ui-no-button flex flex-center-cz flex-center-sp" @click="clear">清空</div>
                <div class="margin-right-s ui-no-button flex flex-center-cz flex-center-sp" @click="showLogs">下发历史</div>
                <div class="margin-left-s ui-yes-button flex flex-center-cz flex-center-sp" @click="confirm">确定</div>          
            </div>

            <SendUpdateLogModal :open="showSendUpdateLogModal" @close="showSendUpdateLogModal = false" :logs="updateLog"></SendUpdateLogModal>

        </div>
    </div>
</template>

<script>
    import RichText from '@/components/richText/RichText' 
    import Select from '@/components/select/Select' 
    import MySwitch from '@/components/switch/Switch'
    import {objToStr,keepContent} from '@/utils/sysUtils'
    import {sendUpdateList} from '@/api/api.js';
    import SendUpdateLogModal from '@/views/modal/SendUpdateLogModal'
    
    

    export default {
        name:'SendUpdateModal',
        created() {
        },
        components:{RichText,MySwitch,SendUpdateLogModal,Select},
        props:{
            title:{},
            mData:{},
            open:{}
        },
        watch:{
            open: {
                handler(newValue) {
                    this.show = newValue;
                    if (newValue) {
                        this.verData = [];
                        this.mData.files.forEach(item => {
                            this.verData.push({"text": item.userName, "value": item.userId});                           
                        });
                        this.formData.content = this.mData.content;
                    }
                },
                immediate: true,
                deep: true 
            },

        },
        data() {
            return {
                selectVer:null,
                verData:[],
                show: null,
                showSendUpdateLogModal: false,
                updateLog:null,
                formData:{
                    allUser: false,
                    onlyUser: false,
                },               
                userName : sessionStorage.getItem("realname"),
            }
        },
        methods:{
            confirm() {
                if (objToStr(this.formData.content).indexOf("data:image/png;base64") > -1) {
                    this.$showToast({
                        msg: '正在处理图片数据，请稍候' 
                    }) 
                    return false;
                }
                console.log("this.formData.selectVer", this.formData.selectVer)
                if (objToStr(this.formData.selectVer) == "") {
                    this.$showToast({
                        msg: '请选择指定人员' 
                    }) 
                    return false;

                }
                this.$emit("confirm", this.formData);

            },
            clear() {
                console.log("11111")
                this.formData.content = '';
                this.$forceUpdate();
            },
            
            close() {
                this.$emit("close")
            },
            keep(value) {
                if (value == 1) {
                    let data = this.$refs.selectVer.getText(this.formData.selectVer);
                    this.formData.content = keepContent(this.formData.content, data);
                }
            },
            showLogs() {
                sendUpdateList(this.mData.docId).then((res) => {
                    console.log(res);
                    if (res.data.success == true) {
                        this.updateLog = res.data.result;
                        this.showSendUpdateLogModal = true;
                    }
                })  
            }
             

        }
   }
</script>

<style scoped>

    .form-modal {
        top: 30px;
    }
    .doc-edit-modal {
        width: 1000px;
        height: 810px;
    }
    .edit-area {
       width: 960px;
    }

    .body .row {
        line-height: 40px;
    }
</style>


// WEBPACK FOOTER //
// src/views/modal/SendUpdateModal.vue